import api from '../../plugins/api';

const generateContract = ({ orderIds, chunkId, dealId }) => {
  return api.post('/api/bucket/generateContract', { orderIds, chunkId, dealId });
};

export default generateContract;
